import { ProductsOrder } from "common/order/ProductsOrder";
import { useState, useEffect } from "react";
import laptop from "assets/images/laptop.png";
import mos from "assets/images/mos.png";
import headphone from "assets/images/headphone.png";
import hard from "assets/images/hard.png";
import sharzher from "assets/images/sharzher.png";
import { ProductsRepair } from "common/order/ProductsRepair";
import "common/order/orders.scss";
// import ComolatePriceModal from "common/order/ComplatePriceModal";
import ComplatePrieModalAdmin from "common/order/ComplatePriceModalAdmin";
import StatusReportModal from "common/order/StatusReportModal";
import UpdateRepairModal from "common/order/UpdateRepairModal";
import UpdateOrderModal from "common/order/UpdateOrderModal";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Filter from "common/order/Filter";
import Addorders from "common/order/Addorders";
import AddRepairsModal from "common/order/AddrepairsModal";
import { sendRequestAPI4 } from "hooks/useAxios";
import { sendRequestAPI2 } from "hooks/useAxios";
import AddOrderModal from "common/order/AddOrderModal";
import Loader from "utils/Loader";
import { RiOrderPlayFill } from "react-icons/ri";
import { useParams } from "react-router-dom";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "../hooks/useAxios2";
import Title from "common/Title";
import Helmet from "react-helmet";
export default function Orderstor({ typeLogin, logo }) {
  const [items, setItems] = useState([{}]);
  const [updater, setUpdater] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  // state info from apiy
  const [orderLists, setOrderLists] = useState([]);
  useEffect(() => {}, []);
  const filterOrder = (filterInput, type) => {
    type == "1"
      ? sendRequestAPI2(
          "newfilterorder",
          { count: 10, page: currentPage },
          filterInput
        ).then(({ data }) => {
          setOrderLists(data.info.reverse());
        })
      : setUpdater((prev) => !prev);
  };
  const [selectedItem, setSelectedItem] = useState({});
  const [chatList, setChatList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const updateSelectedItem = (information) => {
    setSelectedItem(information);
    setChatList(information.chats);
  };
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function loadPage() {
      if (activeTab == 0) {
        await sendRequestAPI2("newfilterorder", {
          count: 10,
          page: currentPage,
          is_seller: 1,
        }).then(({ data }) => {
          setOrderLists(data.info.reverse());
          setTotalCount(data.total_count);
          // console.log("total_count", data.total_count);

          setSelectedItem((prev) => {
            let temp = data.info.find((value) => {
              return value.id == prev?.id;
            });
            if (temp == undefined) {
              return {};
            } else {
              return temp;
            }
          });
          setLoading(false);
        });
      } else if (activeTab == 1) {
        await sendRequestAPI2("newfilterorder", {
          count: 10,
          page: currentPage,
          is_seller: 0,
        }).then(({ data }) => {
          setOrderLists(data.info.reverse());
          setTotalCount(data.total_count);
          // console.log("total_count", data.total_count);

          setSelectedItem((prev) => {
            let temp = data.info.find((value) => {
              return value.id == prev?.id;
            });
            if (temp == undefined) {
              return {};
            } else {
              return temp;
            }
          });
          setLoading(false);
        });
      } else {
        await sendRequestAPI2("newfilterorder", {
          count: 10,
          page: currentPage,
        }).then(({ data }) => {
          setOrderLists(data.info.reverse());
          setTotalCount(data.total_count);
          setSelectedItem((prev) => {
            let temp = data.info.find((value) => {
              return value.id == prev?.id;
            });
            if (temp == undefined) {
              return {};
            } else {
              return temp;
            }
          });
          setLoading(false);
        });
      }
    }
    loadPage();
  }, [updater, currentPage]);
  let typeUser = "shop";
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`سفارشات ادمین`} </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      <Title
        color="rgb(244 124 96)"
        title="لیست سفارشات"
        icon={RiOrderPlayFill}
      />
      {typeLogin == "adminShop" ? (
        <>
          <ul className="nav nav-tabs mt-5" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active text-red"
                id="sale-tab"
                data-bs-toggle="tab"
                data-bs-target="#sale"
                type="button"
                role="tab"
                aria-controls="sale"
                aria-selected="true"
                onClick={() => {
                  setActiveTab(0);
                  setUpdater((prev) => !prev);
                }}
              >
                فروش
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="Buy-tab"
                data-bs-toggle="tab"
                data-bs-target="#Buy"
                type="button"
                role="tab"
                aria-controls="Buy"
                aria-selected="false"
                onClick={() => {
                  setActiveTab(1);
                  setUpdater((prev) => !prev);
                }}
              >
                خرید
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="sale"
              role="tabpanel"
              aria-labelledby="sale-tab"
            >
              <div className="order-container px-4 ">
                {loading && <Loader></Loader>}
                <Filter filterFunction={filterOrder}></Filter>
                {/* <Addorders></Addorders> */}
                <AddOrderModal></AddOrderModal>
                {/* <ComolatePriceModal selectedItem={selectedItem}></ComolatePriceModal> */}

                <StatusReportModal
                  selectedItem={selectedItem}
                  pageType="0"
                  setUpdater={setUpdater}
                  // chats={selectedItem.chats}
                  // chats={chatList}
                  // setChats={setChatList}
                ></StatusReportModal>
                <UpdateRepairModal
                  selectedItem={selectedItem}
                  updateSelectedItem={updateSelectedItem}
                  orderUpdater={setUpdater}
                ></UpdateRepairModal>
                <UpdateOrderModal
                  selectedItem={selectedItem}
                  updateSelectedItem={updateSelectedItem}
                  orderUpdater={setUpdater}
                ></UpdateOrderModal>
                {orderLists.map((value, index) => {
                  // if (value.type == "0") {
                  //   return (
                  //     <ProductsOrder
                  //       data={value}
                  //       index={index}
                  //       updateSelectedItem={updateSelectedItem}
                  //       pageType="superadmin"
                  //       setOrderLists={setOrderLists}
                  //     ></ProductsOrder>
                  //   );
                  // } else {
                  return (
                    <ProductsRepair
                      data2={value}
                      index={index}
                      updateSelectedItem={updateSelectedItem}
                      pageType="superadmin"
                      orderLists={orderLists}
                      setOrderLists={setOrderLists}
                      updater={updater}
                      setUpdater={setUpdater}
                      typeLogin={typeLogin}
                    ></ProductsRepair>
                  );
                  // }
                })}
                {!orderLists.length ? (
                  <h3 style={{ textAlign: "center", marginTop: "10px" }}>
                    سفارشی یافت نشد{" "}
                  </h3>
                ) : (
                  <div className="d-flex justify-content-center mt-4">
                    <div>
                      <Pagination
                        total={totalCount}
                        pageSize={10}
                        current={currentPage}
                        onChange={(newPage) => {
                          setCurrentPage(newPage);
                        }}
                      ></Pagination>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className="tab-pane fade "
              id="Buy"
              role="tabpanel"
              aria-labelledby="Buy-tab"
            >
              <div className="order-container px-4 ">
                {loading && <Loader></Loader>}
                <Filter filterFunction={filterOrder}></Filter>
                {/* <Addorders></Addorders> */}
                <AddOrderModal></AddOrderModal>
                {/* <ComolatePriceModal selectedItem={selectedItem}></ComolatePriceModal> */}

                <StatusReportModal
                  selectedItem={selectedItem}
                  pageType="0"
                  setUpdater={setUpdater}
                  // chats={selectedItem.chats}
                  // chats={chatList}
                  // setChats={setChatList}
                ></StatusReportModal>
                <UpdateRepairModal
                  selectedItem={selectedItem}
                  updateSelectedItem={updateSelectedItem}
                  orderUpdater={setUpdater}
                ></UpdateRepairModal>
                <UpdateOrderModal
                  selectedItem={selectedItem}
                  updateSelectedItem={updateSelectedItem}
                  orderUpdater={setUpdater}
                ></UpdateOrderModal>
                {orderLists.map((value, index) => {
                  // if (value.type == "0") {
                  //   return (
                  //     <ProductsOrder
                  //       data={value}
                  //       index={index}
                  //       updateSelectedItem={updateSelectedItem}
                  //       pageType="superadmin"
                  //       setOrderLists={setOrderLists}
                  //     ></ProductsOrder>
                  //   );
                  // } else {
                  return (
                    <ProductsRepair
                      data2={value}
                      index={index}
                      updateSelectedItem={updateSelectedItem}
                      pageType="superadmin"
                      orderLists={orderLists}
                      setOrderLists={setOrderLists}
                      updater={updater}
                      setUpdater={setUpdater}
                      typeLogin={typeLogin}
                    ></ProductsRepair>
                  );
                  // }
                })}
                {!orderLists.length ? (
                  <h3 style={{ textAlign: "center", marginRight: "10px" }}>
                    سفارشی یافت نشد
                  </h3>
                ) : (
                  <div className="d-flex justify-content-center mt-4">
                    <div>
                      <Pagination
                        total={totalCount}
                        pageSize={10}
                        current={currentPage}
                        onChange={(newPage) => {
                          setCurrentPage(newPage);
                        }}
                      ></Pagination>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="order-container ">
          {loading && <Loader></Loader>}
          <Filter filterFunction={filterOrder}></Filter>
          {/* <Addorders></Addorders> */}
          <AddOrderModal></AddOrderModal>
          {/* <ComolatePriceModal selectedItem={selectedItem}></ComolatePriceModal> */}

          <StatusReportModal
            selectedItem={selectedItem}
            pageType="0"
            setUpdater={setUpdater}
            // chats={selectedItem.chats}
            // chats={chatList}
            // setChats={setChatList}
          ></StatusReportModal>
          <UpdateRepairModal
            selectedItem={selectedItem}
            updateSelectedItem={updateSelectedItem}
            orderUpdater={setUpdater}
          ></UpdateRepairModal>
          <UpdateOrderModal
            selectedItem={selectedItem}
            updateSelectedItem={updateSelectedItem}
            orderUpdater={setUpdater}
          ></UpdateOrderModal>
          {orderLists.map((value, index) => {
            // if (value.type == "0") {
            //   return (
            //     <ProductsOrder
            //       data={value}
            //       index={index}
            //       updateSelectedItem={updateSelectedItem}
            //       pageType="superadmin"
            //       setOrderLists={setOrderLists}
            //     ></ProductsOrder>
            //   );
            // } else {
            return (
              <ProductsRepair
                data2={value}
                index={index}
                updateSelectedItem={updateSelectedItem}
                pageType="superadmin"
                updater={updater}
                setUpdater={setUpdater}
                typeLogin={typeLogin}
              ></ProductsRepair>
            );
            // }
          })}
          {!orderLists.length ? (
            <h3 style={{ textAlign: "center", marginTop: "10px" }}>
              سفارشی یافت نشد
            </h3>
          ) : (
            <div className="d-flex justify-content-center mt-4">
              <div>
                <Pagination
                  total={totalCount}
                  pageSize={10}
                  current={currentPage}
                  onChange={(newPage) => {
                    setCurrentPage(newPage);
                  }}
                ></Pagination>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
